<template>
  <div class="bigSchoolIntroduction-page">
    <div class="cross" v-if="screenType == 0">
      <div class="swiper-containerFocus">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in swiperList"
            :key="index"
          >
            <img
              :src="require('../../../../assets/themes/img/teasLogin/bg.jpg')"
              class="swiper-img"
            />
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div v-else class="vertical">
    </div>
  </div>
</template>

<script>
export default {
  name: "bigSchoolIntroduction",
  data() {
    return {
      swiperList: [1, 2, 3],
    };
  },
  created() {
    this.loadScript(() => {
      this.$nextTick(() => {
        this.initSwiper();
      });
    });
    this.screenType = this.$route.meta.screenType;

    this.getData();
  },
  methods: {
    getData() {
      // this.$http
      //   .get(this.url, {
      //     pageSize: this.maxTags,
      //   })
      //   .then(({ data }) => {
      //     if (data && data.success) {
      //       this.swiperList = data.data;
      //     }
      //   })
      //   .catch(() => {
      //     this.swiperList = [];
      //   });
    },
    // 初始化swiper
    async initSwiper() {
      const _this = this;
      this.$nextTick(() => {
        this.mySwiper = new Swiper(".swiper-containerFocus", {
          autoplay:true,
          pagination: {
            el: ".swiper-pagination",
          },
          //loop: true, // 循环模式选项
          // centeredSlides: true,
          // centeredSlidesBounds: true,
          on: {},
        });
      });
    },
    // prev() {
    //   this.mySwiper.slidePrev();
    // },
    // next() {
    //   this.mySwiper.slideNext();
    // },
    // 加载js
    loadScript(callback) {
      this.$http
        .importFiles([
          dsf.url.getWebPath("$/js/libs/swiper/swiper-bundle.min.css"),
          dsf.url.getWebPath("$/js/libs/swiper/swiper-bundle.min.js"),
        ])
        .then(() => {
          callback?.();
        })
        .catch(() => {
          dsf.layer.message("加载fabric文件报错", false);
          reject();
        });
    },
  },
};
</script>

<style>
</style>